import React from 'react';
import { Box, Typography } from '@mui/material';
import { Person } from '@mui/icons-material';
import { GraphUser } from '../../../../../utils/MsGraphApiCall';

interface UserSearchOptionProps extends React.HTMLAttributes<HTMLLIElement> {
  user: GraphUser;
}

export const UserSearchOption: React.FC<UserSearchOptionProps> = ({ user, ...props }) => (
  <Box component="li" {...props}>
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <Person sx={{ mr: 1, color: 'action.active' }} />
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {user.displayName}
        </Typography>
        {user.mail && (
          <Typography variant="caption" color="text.secondary">
            {user.mail}
          </Typography>
        )}
      </Box>
    </Box>
  </Box>
);
